import { supabase } from '../supabase';

const FUNCTION_NAME = 'send-email';

async function invokeEmail(payload) {
    const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, {
        body: payload,
    });

    if (error) {
        throw error;
    }

    return data;
}

export function sendEmail(template, to, data = {}, options = {}) {
    return invokeEmail({
        template,
        to,
        data,
        ...options,
    });
}

export function sendProviderNotification(to, data, options = {}) {
    return sendEmail('provider-notification', to, data, options);
}

export function sendBookingAccepted(to, data, options = {}) {
    return sendEmail('booking-accepted', to, data, options);
}

export function sendBookingRejected(to, data, options = {}) {
    return sendEmail('booking-rejected', to, data, options);
}

export function sendWorkCompleted(to, data, options = {}) {
    return sendEmail('work-completed', to, data, options);
}

export function sendWelcomeProvider(to, data, options = {}) {
    return sendEmail('welcome-provider', to, data, options);
}

export function sendProviderApplicationReceived(to, data, options = {}) {
    return sendEmail('provider-application-received', to, data, options);
}

export function sendAdminNewApplication(to, data, options = {}) {
    return sendEmail('admin-new-application', to, data, options);
}

export function sendGenericNotification(to, data, options = {}) {
    return sendEmail('generic-notification', to, data, options);
}
